import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastNoAnimation } from 'ngx-toastr';
import { NotificationType } from './notification-type';

/**
 * Extends `ToastNoAnimation`, not `Toast` (LBRD-6308): `Toast` carries an
 * `@angular/animations` trigger, and rendering it makes `provideAnimationsAsync()`
 * lazy-load the legacy animation engine. From then on that engine owns DOM removal
 * app-wide and breaks Material's CSS-driven overlay exit animations -- e.g. the
 * shipment list's status-filter panel blinks as it closes. The toast fade-in lives
 * in styles.scss instead.
 */
@Component({
  selector: 'lbt-notification',
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
  imports: [CommonModule],
})
export class NotificationComponent extends ToastNoAnimation {
  private readonly iconMap: Record<NotificationType, string> = {
    [NotificationType.Success]: '&#10003;',
    [NotificationType.Error]: '&#10005;',
    [NotificationType.Warning]: '&#33;',
    [NotificationType.Info]: '&#9432;',
  };

  get toastType(): NotificationType {
    const type = this.options?.payload?.type as NotificationType | undefined;
    return type ?? NotificationType.Info;
  }

  get icon(): string {
    return this.iconMap[this.toastType] ?? '';
  }
}
